export default "__VITE_ASSET__CqCHSif3__"